
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-faq",
      function () {
        return require("private-next-pages/contact-faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-faq"])
      });
    }
  